import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'

const defaultState = () => ({
  listviewData: ref([]),
  init: ref(1),
  loading: ref(false),
  perPage: ref(27),
  totalRows: ref(0),
  currentPage: ref(1),
  searchTxt: ref(''),
  totalFieldsFilter: ref(0),
  showListviewFilter: ref(false),
  orderBy: ref({
    column: 'sw012v02',
    sort: 'asc',
  }),
  txtSearchPlaceholder: i18n.t('ZMID'),
  txtLoading: i18n.t('A carregar registos ...'),
  txtDefault: i18n.t('Nenhum imóvel disponível'),
  txtNotFind: i18n.t('Não encontrou nenhum resultado'),
  fieldsOrder: [
    {
      name: 'status',
      txt: i18n.t('Ordenar por estado'),
    },
    {
      name: 'sw012v02',
      txt: i18n.t('Ordenar por ZMID'),
    },
    {
      name: 'local',
      txt: i18n.t('Ordenar por local'),
    },
    {
      name: 'tipologia',
      txt: i18n.t('Ordenar por tipologia'),
    },
    {
      name: 'price',
      txt: i18n.t('Ordenar por preço'),
    },
  ],
})

export default defaultState
